import { z } from "zod";
import { schemaRawTransaction } from "../../families";
const schemaTransactionOptions = z.object({
    hwAppId: z.string().optional(),
});
const schemaTransactionSignAndBroadcastParams = z.object({
    accountId: z.string(),
    rawTransaction: schemaRawTransaction,
    options: schemaTransactionOptions.optional(),
    meta: z.record(z.string(), z.unknown()).optional(),
});
const schemaTransactionSignAndBroadcastResults = z.object({
    transactionHash: z.string(),
});
export const schemaTransactionSignAndBroadcast = {
    params: schemaTransactionSignAndBroadcastParams,
    result: schemaTransactionSignAndBroadcastResults,
};
//# sourceMappingURL=TransactionSignAndBroadcast.js.map